export interface GameConfig {
  CANVAS_WIDTH: number;
  CANVAS_HEIGHT: number;
  TILE_SIZE: number;
  BACKGROUND_COLOR: string;
}

export const GAME_CONFIG: GameConfig = {
  CANVAS_WIDTH: 320,
  CANVAS_HEIGHT: 180,
  TILE_SIZE: 16,
  BACKGROUND_COLOR: '#2a2140',
};
